<template>
  <div class="contact-page">
    <!-- SEO Meta Tags -->
    <meta name="description" content="Modern Kurs Kozan ile iletişime geçin. Adres: Kozan/Adana, Telefon: 0552 683 34 03 - 0552 683 34 09, E-posta: modernkurs01@gmail.com. Çalışma saatleri ve konum bilgileri." />
    <meta name="keywords" content="modern kurs kozan iletişim, kozan eğitim merkezi telefon, kozan kurs adresi, modern kurs adana, kozan öğretmen iletişim" />
    <meta name="author" content="Modern Kurs Kozan" />
    <meta property="og:title" content="İletişim - Modern Kurs Kozan" />
    <meta property="og:description" content="Modern Kurs Kozan ile iletişime geçin. Kozan/Adana adres, telefon ve e-posta bilgileri." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://modernkurs.com/contact" />
    
    <!-- Navigation Bar -->
    <CorporateNavbar />
    
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="container">
        <div class="hero-content">
          <h1 class="hero-title">İletişim</h1>
          <p class="hero-subtitle">Bizimle iletişime geçin</p>
        </div>
      </div>
    </section>

    <!-- Main Content -->
    <main class="main-content">
      <div class="container">
        <!-- Social Media -->
        <div class="social-media-section" v-if="socialMediaData">
          <h3>🌐 Sosyal Medya</h3>
          <div class="social-links">
            <a v-if="socialMediaData.instagram" :href="socialMediaData.instagram" target="_blank" class="social-link">
              <svg class="social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              <span>Instagram</span>
            </a>

            <a v-if="socialMediaData.youtube" :href="socialMediaData.youtube" target="_blank" class="social-link">
              <svg class="social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
              <span>YouTube</span>
            </a>
            <a v-if="socialMediaData.facebook" :href="socialMediaData.facebook" target="_blank" class="social-link">
              <svg class="social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
              <span>Facebook</span>
            </a>
            <a v-if="socialMediaData.twitter" :href="socialMediaData.twitter" target="_blank" class="social-link">
              <svg class="social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
              <span>X (Twitter)</span>
            </a>
          </div>
        </div>
        


        <div class="contact-info-section" v-if="contactData">
            <h2>{{ contactData.title || '📞 İletişim Bilgileri' }}</h2>
            
            <div class="contact-cards">
              <div class="contact-card">
                <div class="card-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
                </div>
                <div class="card-content">
                  <h4>Adres</h4>
                  <a href="https://www.google.com/maps?q=37.461503125207315,35.82148209864696" target="_blank" class="address-link">
                    {{ contactData.address || 'Modern Kurs Merkezi, Göç Yolu Yusuf Baysal Sitesi Edem Pastanesi Üstü, Tufanpaşa, Kozan/Adana' }}
                  </a>
                </div>
              </div>
              
              <div class="contact-card">
                <div class="card-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                  </svg>
                </div>
                <div class="card-content">
                  <h4>Telefon</h4>
                  <div class="phone-numbers">
                    <a href="tel:05526833403" class="phone-link">0552 683 34 03</a>
                    <span class="phone-separator">-</span>
                    <a href="tel:05526833409" class="phone-link">0552 683 34 09</a>
                  </div>
                </div>
              </div>
              
              <div class="contact-card">
                <div class="card-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z"/>
                  </svg>
                </div>
                <div class="card-content">
                  <h4>Sabit Telefon</h4>
                  <p>
                    <a href="tel:03225150405" class="phone-link">{{ contactData.phone2 || '0322 515 04 05' }}</a>
                  </p>
                </div>
              </div>
              
              <div class="contact-card">
                <div class="card-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                </div>
                <div class="card-content">
                  <h4>E-posta</h4>
                  <a href="mailto:modernkurs01@gmail.com" class="email-link">
                    {{ contactData.email || 'modernkurs01@gmail.com' }}
                  </a>
                </div>
              </div>
              
              <div class="contact-card working-hours-card">
                <div class="card-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
                    <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                  </svg>
                </div>
                <div class="card-content">
                  <h4>Çalışma Saatleri</h4>
                  <p>{{ contactData.working_hours || 'Pazartesi - Cuma: 08:00 - 19:00, Cumartesi - Pazar: 08:00 - 19:00' }}</p>
                </div>
              </div>
            </div>
          </div>
        
        <!-- Map Section -->
        <section class="map-section">
          <h2>🗺️ Konum</h2>
          <div class="map-container">
            <iframe 
              src="https://maps.google.com/maps?q=37.461503125207315,35.82148209864696&hl=tr&z=18&output=embed"
              width="100%" 
              height="450" 
              style="border:0;" 
              allowfullscreen="" 
              loading="lazy" 
              referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </section>
        
        <!-- FAQ Section -->
        <section class="faq-section">
          <h2>❓ Sık Sorulan Sorular</h2>
          <div class="faq-grid">
            <div class="faq-item">
              <div class="faq-question" @click="toggleFaq(1)">
                <h4>Kursunuzda hangi sınıflara yönelik eğitim verilmektedir?</h4>
                <span class="faq-icon">{{ openFaq === 1 ? '−' : '+' }}</span>
              </div>
              <div class="faq-answer" v-show="openFaq === 1">
                <p>Kursumuzda 9, 10 ve 11. sınıflar için okul derslerine paralel çalışmalar; 12. sınıf ve mezun gruplar için ise üniversite hazırlık programları uygulanmaktadır.</p>
              </div>
            </div>
            
            <div class="faq-item">
              <div class="faq-question" @click="toggleFaq(2)">
                <h4>Hangi dersler program kapsamında yer almaktadır?</h4>
                <span class="faq-icon">{{ openFaq === 2 ? '−' : '+' }}</span>
              </div>
              <div class="faq-answer" v-show="openFaq === 2">
                <p>Programlarımızda Türkçe, Matematik, Fizik, Kimya, Biyoloji, Geometri, Tarih, Coğrafya, Felsefe Grubu ve üniversite hazırlık sürecinde TYT–AYT'nin tüm dersleri yer almaktadır.</p>
              </div>
            </div>
            
            <div class="faq-item">
              <div class="faq-question" @click="toggleFaq(3)">
                <h4>Ders saatleri nasıl planlanmaktadır?</h4>
                <span class="faq-icon">{{ openFaq === 3 ? '−' : '+' }}</span>
              </div>
              <div class="faq-answer" v-show="openFaq === 3">
                <p>Haftalık ders programlarımız öğrencilerimizin seviyelerine ve hedeflerine göre hazırlanır. Ders saatleri dönem başında duyurulur, yaz ve kış programlarımız farklılık gösterebilir.</p>
              </div>
            </div>
            
            <div class="faq-item">
              <div class="faq-question" @click="toggleFaq(4)">
                <h4>Deneme sınavı uyguluyor musunuz?</h4>
                <span class="faq-icon">{{ openFaq === 4 ? '−' : '+' }}</span>
              </div>
              <div class="faq-answer" v-show="openFaq === 4">
                <p>Evet. Düzenli aralıklarla kurum içi denemeler yapılmakta, ayrıca öğrencilerimiz Türkiye geneli denemelere katılarak başarı düzeylerini görmektedir.</p>
              </div>
            </div>
            
            <div class="faq-item">
              <div class="faq-question" @click="toggleFaq(5)">
                <h4>Bireysel soru çözümü imkânı var mıdır?</h4>
                <span class="faq-icon">{{ openFaq === 5 ? '−' : '+' }}</span>
              </div>
              <div class="faq-answer" v-show="openFaq === 5">
                <p>Evet. Öğrencilerimizin ihtiyaçlarına yönelik birebir soru çözümü ve ek etüt dersleri sunulmaktadır.</p>
              </div>
            </div>
            
            <div class="faq-item">
              <div class="faq-question" @click="toggleFaq(6)">
                <h4>Rehberlik ve öğrenci koçluğu hizmeti veriliyor mu?</h4>
                <span class="faq-icon">{{ openFaq === 6 ? '−' : '+' }}</span>
              </div>
              <div class="faq-answer" v-show="openFaq === 6">
                <p>Evet. Akademik gelişimi takip etmek, çalışma planlarını düzenlemek ve motivasyonu artırmak amacıyla rehberlik ve öğrenci koçluğu hizmetimiz mevcuttur.</p>
              </div>
            </div>
            
            <div class="faq-item">
              <div class="faq-question" @click="toggleFaq(7)">
                <h4>Sınıflarınız kaç kişiliktir?</h4>
                <span class="faq-icon">{{ openFaq === 7 ? '−' : '+' }}</span>
              </div>
              <div class="faq-answer" v-show="openFaq === 7">
                <p>Sınıflarımız seviye sınıfları şeklinde oluşturulmakta olup az öğrenci sayısıyla, butik eğitim anlayışıyla oluşturulmaktadır.</p>
              </div>
            </div>
            
            <div class="faq-item">
              <div class="faq-question" @click="toggleFaq(8)">
                <h4>Kurs ücretleriniz nedir?</h4>
                <span class="faq-icon">{{ openFaq === 8 ? '−' : '+' }}</span>
              </div>
              <div class="faq-answer" v-show="openFaq === 8">
                <p>Ücretler, program türü ve ders saatlerine göre değişiklik göstermektedir. Detaylı bilgi için lütfen kurumumuzla iletişime geçiniz.</p>
              </div>
            </div>
            
            <div class="faq-item">
              <div class="faq-question" @click="toggleFaq(9)">
                <h4>Kayıt için hangi belgeler gereklidir?</h4>
                <span class="faq-icon">{{ openFaq === 9 ? '−' : '+' }}</span>
              </div>
              <div class="faq-answer" v-show="openFaq === 9">
                <p>Kayıt sırasında öğrenci ve veli kimlikleri ile iletişim bilgileri yeterlidir.</p>
              </div>
            </div>
            
            <div class="faq-item">
              <div class="faq-question" @click="toggleFaq(10)">
                <h4>Kurumunuza ulaşım kolay mıdır?</h4>
                <span class="faq-icon">{{ openFaq === 10 ? '−' : '+' }}</span>
              </div>
              <div class="faq-answer" v-show="openFaq === 10">
                <p>Kurumumuz şehir merkezinde yer almakta olup, toplu taşıma araçlarıyla ulaşım oldukça kolaydır. Adres ve konum bilgisi iletişim sayfamızda yer almaktadır.</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
    
    <!-- WhatsApp Floating Button -->
    <WhatsAppButton />

    <!-- Footer -->
    <CorporateFooter />
  </div>
</template>

<script>
import { ref } from 'vue'
import CorporateNavbar from '@/components/CorporateNavbar.vue'
import CorporateFooter from '@/components/CorporateFooter.vue'
import WhatsAppButton from '@/components/WhatsAppButton.vue'

export default {
  name: 'Contact',
  components: {
    CorporateNavbar,
    CorporateFooter,
    WhatsAppButton
  },
  setup() {
    const contactData = ref({})
    const socialMediaData = ref({})
    const openFaq = ref(null)
    
    // Contact sayfası statik verileri
    contactData.value = {
      title: 'İletişim',
      address: 'Modern Kurs Merkezi, Göç Yolu Yusuf Baysal Sitesi Edem Pastanesi Üstü, Tufanpaşa, Kozan/Adana',
      phone: '05526833403 - 05526833409',
      phone2: '0322 515 04 05',
      email: 'modernkurs01@gmail.com',
      working_hours: 'Pazartesi - Cuma: 08:00 - 19:00, Cumartesi - Pazar: 08:00 - 19:00'
    }
    
          socialMediaData.value = {
        facebook: 'https://facebook.com/modern.kurs.7',
        twitter: 'https://twitter.com/kursmodern?s=21',
        instagram: 'https://instagram.com/modern_kurs',
        youtube: 'https://youtube.com/@modernkurs2739'
      }
    
    const toggleFaq = (id) => {
      openFaq.value = openFaq.value === id ? null : id
    }
    
    return {
      contactData,
      socialMediaData,
      openFaq,
      toggleFaq
    }
  }
}
</script>

<style scoped>
.contact-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  margin-top: 80px; /* Navbar yüksekliği kadar margin */
  overflow-x: hidden;
  width: 100%;
}



/* Hero Section */
.hero-section {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  color: white;
  padding: 3rem 0;
  text-align: center;
  margin-top: 55px;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  opacity: 0.3;
}

.hero-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
}

.hero-subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  position: relative;
  z-index: 1;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Main Content */
.main-content {
  padding: 1rem 0;
  flex: 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}



/* Contact Info Section */
.contact-info-section {
  max-width: 800px;
  margin: 0 auto;
  margin-top: 2rem;
}

.contact-info-section h2 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 2rem;
  text-align: center;
}

.contact-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.contact-card {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
}

.contact-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.contact-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.card-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  color: white;
}

.card-icon svg {
  width: 28px;
  height: 28px;
}

.card-content h4 {
  color: #2c3e50;
  margin-bottom: 1rem;
  font-size: 1.3rem;
  font-weight: 600;
}

.card-content p {
  color: #555;
  line-height: 1.6;
  margin: 0;
  font-size: 1rem;
}

.address-link {
  color: #555;
  text-decoration: none;
  line-height: 1.6;
  margin: 0;
  font-size: 1rem;
  transition: color 0.3s ease;
  cursor: pointer;
}

.address-link:hover {
  color: #667eea;
  text-decoration: underline;
}

.phone-link {
  color: #555;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
  cursor: pointer;
}

.phone-link:hover {
  color: #667eea;
  text-decoration: underline;
}

.email-link {
  color: #555;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
  cursor: pointer;
  display: inline-block;
  line-height: 1.6;
  margin: 0;
}

.email-link:hover {
  color: #667eea;
  text-decoration: underline;
}

.phone-numbers {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.phone-separator {
  color: #999;
  font-weight: 400;
  font-size: 0.9rem;
}

/* Social Media */
.social-media-section {
  margin-top: 2rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.social-media-section h3 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 1.5rem;
}

.social-links {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.social-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.8rem 1.2rem;
  background: white;
  border-radius: 25px;
  text-decoration: none;
  color: #2c3e50;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.social-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  color: #667eea;
}

.social-icon {
  width: 1.2rem;
  height: 1.2rem;
  flex-shrink: 0;
}

/* Working Hours Card - İki kart büyüklüğünde */
.working-hours-card {
  grid-column: span 2;
}



/* Map Section */
.map-section {
  margin-bottom: 5rem;
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2rem;
}

.map-section h2 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 2rem;
}

.map-container {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-top: 2rem;
}



/* FAQ Section */
.faq-section {
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.faq-section h2 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 3rem;
}

.faq-grid {
  display: grid;
  gap: 1.5rem;
  max-width: 800px;
  margin: 0 auto;
}

.faq-item {
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.faq-question:hover {
  background-color: #f8f9fa;
}

.faq-question h4 {
  color: #2c3e50;
  margin: 0;
  font-size: 1.1rem;
}

.faq-icon {
  font-size: 1.5rem;
  color: #667eea;
  font-weight: bold;
}

.faq-answer {
  padding: 0 1.5rem 1.5rem;
  text-align: left;
}

.faq-answer p {
  color: #555;
  line-height: 1.6;
  margin: 0;
}

/* Responsive */
@media (max-width: 1200px) {
  .container {
    max-width: 1000px;
    padding: 0 2rem;
  }
  
  .contact-cards {
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
  
  .working-hours-card {
    grid-column: span 2;
  }
  
  .faq-grid {
    max-width: 900px;
  }
}

@media (max-width: 768px) {
  .container {
    max-width: 100%;
    padding: 0 1.5rem;
  }
  
  .hero-title {
    font-size: 2.5rem;
  }
  
  .contact-cards {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .working-hours-card {
    grid-column: span 1;
  }
  
  .email-link {
    font-size: 0.9rem;
  }
  
  .contact-card {
    padding: 1.5rem;
  }
  
  .card-icon {
    width: 50px;
    height: 50px;
  }
  
  .card-content h4 {
    font-size: 1.1rem;
  }
  
  .card-content p {
    font-size: 0.9rem;
  }
  
  .social-links {
    justify-content: center;
  }
  
  .faq-grid {
    max-width: 100%;
  }
  
  .map-container iframe {
    height: 350px;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 2rem;
  }
  
  .container {
    padding: 0 1rem;
  }
  
  .contact-cards {
    gap: 1rem;
  }
  
  .contact-card {
    padding: 1rem;
  }
  
  .card-icon {
    width: 45px;
    height: 45px;
  }
  
  .card-content h4 {
    font-size: 1rem;
  }
  
  .card-content p {
    font-size: 0.85rem;
  }
  
  .map-container iframe {
    height: 300px;
  }
}
</style>
